import {Injectable} from '@angular/core';
import {GruppeId, Tidssone} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {BrukerkontekstTilbyder} from "../BrukerkontekstTilbyder";
import {BehaviorSubject, merge, Observable, of} from "rxjs";
import {map} from "rxjs/operators";


/**
 * Tjeneste som gir tilgang til gjeldende tidssone.
 */
@Injectable()
export class GjeldendeTidssone {

    private standardTidssoneStrøm_: Observable<Tidssoneinformasjon>;

    constructor(private readonly kontekstTilbyder: BrukerkontekstTilbyder) {
        this.standardTidssoneStrøm_ = merge(
          of(this.standardTidssone()), //gir en initiell verdi
          this.kontekstTilbyder.autentisertBrukerSomStrøm()
            .pipe(map(kontekst => Tidssoneinformasjon.fraJavaTimeZone(kontekst.bruker.tidssone))));
    }

    /** Brukers tidssone, {@link #standardTidssone()} dersom ingen autentisert bruker finnes. */
    brukersTidssone(): Tidssoneinformasjon {
        if (this.kontekstTilbyder.erIkkeAutentisert()) return this.standardTidssone();
        return Tidssoneinformasjon.fraJavaTimeZone(this.kontekstTilbyder.autentisertBruker().bruker.tidssone);
    }

    brukersTidssoneSomStrøm(): Observable<Tidssoneinformasjon> {
        return this.standardTidssoneStrøm_;
    }

    gruppensTidssone(id: GruppeId): Tidssoneinformasjon {
        if (this.kontekstTilbyder.erIkkeAutentisert()) return this.standardTidssone();
        return Tidssoneinformasjon.fraJavaTimeZone(this.kontekstTilbyder.autentisertBruker().finnAutentiserteGruppe(id)!.oppsett.tidssone);
    }

    //hjelpemetoder

    /** Returnerer tidssone basert på nettleseroppsett e.l.
     * @todo les nettleser, i ajs er dette gjort med moment.tz.guess(); */
    private standardTidssone() {
        //en siste utvei:
        return Tidssoneinformasjon.standardTidssone;
    }
}

/** Returnerer en {@link GjeldendeTidssone} instans som leverer angitt statisk tidssone i alle kall. */
export function gjeldendeTidssoneStatisk(tidssone: Tidssoneinformasjon): GjeldendeTidssone {
    return {
        brukersTidssone(): Tidssoneinformasjon {
            return tidssone;
        },
        brukersTidssoneSomStrøm(): Observable<Tidssoneinformasjon> {
            return new BehaviorSubject(tidssone);
        },
        gruppensTidssone(id: GruppeId): Tidssoneinformasjon {
            return tidssone;
        }

    } as GjeldendeTidssone
}

export class Tidssoneinformasjon {

    static UTC = new Tidssoneinformasjon('UTC');
    static CET = new Tidssoneinformasjon('CET');
    static standardTidssone = Tidssoneinformasjon.UTC;

    /** Oppretter Tidssoneinformasjon fra tidssonerepresentasjon vi opererer med på java-siden.
     * Se no.systemfabrikken.lederplan.domene.bruker.Tidssone .
     * Verdien er en gyldig tidssone iht. java.data.TimeZone. */
    static fraJavaTimeZone(soneId: Tidssone): Tidssoneinformasjon {
        return new Tidssoneinformasjon(soneId);
    }

    constructor(private tidssonestreng: Tidssone) {
    }

    /** strengrepresentasjon enkodet som 'Time zone abbreviation', feks CET.
     * se https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
    somZoneId(): Tidssone {
        return this.tidssonestreng;
    }
}
